import { config } from "@/config";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import type { StatusSummary } from "./types";

export async function getStatusSummary(): Promise<StatusSummary> {
  if (!config.statusApiUrl) {
    throw new Error("Status API URL not configured");
  }

  const response = await axios.get<StatusSummary>(config.statusApiUrl);
  return response.data;
}

export function useStatusSummary() {
  return useQuery<StatusSummary>({
    queryKey: ["incidentio", "status-summary"],
    queryFn: getStatusSummary,
    enabled: !!config.statusApiUrl, // Only enable if URL is configured
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchInterval: 5 * 60 * 1000, // Refetch every 5 minutes
    retry: 2,
  });
}
